// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2I97y","large":"styles_large__2UVZP"};